import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from "react-redux"
import { Button } from 'reactstrap';
import EditingScreenShot from './EditingScreenShot';
import html2canvas from "html2canvas"
import * as Actions from "../../../store/actions"
import Swal from 'sweetalert2';
import EventBus from "./editor/eventBus"

const ScreenShots = (props) => {

    const dispatch = useDispatch()

    const [SelectedID, setSelectedID] = useState(0);
    const [IsEditing, setIsEditing] = useState(false);


    const Userdata = useSelector(({ auth }) => auth.UserData);

    const baseURL = useSelector(({ utils }) => utils.baseURL);

    const ImagesToMap = useSelector(({ meeting }) => meeting.ScreenShotImages)



    const [IsLoading, setIsLoading] = useState(false)

    // useEffect(()=>{
    //     [""].length == 1 ? setSelectedID(0) : setSelectedID(null)
    // },[])
    useEffect(() => {
        if (IsEditing) {
            props.setStageHere(2)
        }
        if (!IsEditing) {
            props.setStageHere(1)
        }
    }, [IsEditing])

    async function ssSaver() {
        setIsLoading(true)

        if (document.getElementById("MyNewCross")) document.getElementById("MyNewCross").style.visibility = "hidden"
        document.getElementById("tools").style.visibility = "hidden"

        const canvas = await html2canvas(document.getElementById("theEditor"))

        document.getElementById("tools").style.visibility = "visible"
        if (document.getElementById("MyNewCross")) document.getElementById("MyNewCross").style.visibility = "visible"


        // console.log(canvas.toDataURL())
        setIsLoading(false)

        Upload(canvas.toDataURL())
    }



    function Upload(e) {
        setIsLoading(true)
        dispatch(Actions.SavingScreenShotOFpatient(e)).then(() => {
            setIsLoading(false)
            // props.onSelectAnotherPicture()
            setIsEditing(false)
            EventBus.emit(EventBus.PICK_VERSION, 0);
        })
    }


    if (IsEditing) {
        return (

            <EditingScreenShot
                onSave={() => ssSaver()}
                IsLoading={IsLoading}
                SelectedID={SelectedID}
                onSelectAnotherPicture={() => setIsEditing(false)}
                theImg={ImagesToMap[SelectedID]}
                isFromRom={false}

            />
        )
    }


    return (
        <div className="ScreenShotSection">
            <div className="heading">
                <p>
                    Select any screenshot and click the "Next" Button
                    to start editing it.
                </p>
            </div>
            <div className="ScreenshotContiner">
                {
                    ImagesToMap.map((value, index) => {
                        // ["", ].map((value, index) => {
                        return (
                            <span
                                key={index}
                                onClick={() => {
                                    if (SelectedID === index) return setSelectedID(null)
                                    setSelectedID(index)
                                }}
                                className={`screenshotdiv ${index == SelectedID ? "active" : ""}`}>
                                {
                                    SelectedID == index ? (
                                        <img
                                            className="theCheckImage"
                                            src="/images/check-circle.svg"
                                        />
                                    ) : null
                                }
                                <img
                                    src={value}
                                // src="/images/background.jpg"
                                />
                            </span>
                        )
                    })
                }
            </div>
            <div className="NextButton">
                <Button
                    onClick={() => {
                        setIsEditing(true)
                    }}
                    disabled={SelectedID == null}
                    color="primary"
                    style={{ width: "100px" }}>
                    Next
                </Button>
            </div>

        </div>
    )
}

export default ScreenShots
